// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes cp-spin__gcFQred791GFVqluefOr {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spin__cSlR0KG2ydLnzVkkbwdj {
  animation: cp-spin__gcFQred791GFVqluefOr 1s linear infinite;
}

.searchbox__LfVxJ7Te2Dle6scWlkNw {
  background-color: var(--cp-white);
  font-weight: 400;
  box-shadow: none;
  padding: 0px 8px;
  min-width: 160px;
  /* align to far right */
  margin-left: auto;
}
.searchbox__LfVxJ7Te2Dle6scWlkNw:disabled::placeholder {
  color: var(--cp-textDisabled);
}
`, "",{"version":3,"sources":["webpack://./src/components/StatusDialog/StatusDialog.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2DAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":["@keyframes cp-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: cp-spin 1s linear infinite;\n}\n\n.searchbox {\n  background-color: var(--cp-white);\n  font-weight: 400;\n  box-shadow: none;\n  padding: 0px 8px;\n  min-width: 160px;\n  /* align to far right */\n  margin-left: auto;\n}\n.searchbox:disabled::placeholder {\n  color: var(--cp-textDisabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spin": `spin__cSlR0KG2ydLnzVkkbwdj`,
	"cp-spin": `cp-spin__gcFQred791GFVqluefOr`,
	"searchbox": `searchbox__LfVxJ7Te2Dle6scWlkNw`
};
export default ___CSS_LOADER_EXPORT___;
